import { useState, useEffect, useMemo } from 'react';
import { VideoTrimmerClient } from "../Utils/videoUtils/videoTrim.client";
import { VideoPreview } from '../Controls/VideoPreview';
import './css/ClipPreview.css';

interface ClipPreviewProps {
    video: ArrayBuffer;
    aspectRatio: number;
    startSecs: number | null;
    durationSecs: number | null;
}

export const ClipPreview: React.FC<ClipPreviewProps> = ({ video, aspectRatio, startSecs, durationSecs }) => {
    const [trimmedUrl, setTrimmedUrl] = useState<string | undefined>();
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);

    const extractor = useMemo(() => new VideoTrimmerClient(), []);

    useEffect(() => {
        if (video && startSecs !== null && durationSecs !== null) {
            let cancelled = false;
            let objectUrl: string | null = null;

            const file = new File([video], "input.mp4", { type: "video/mp4" });

            const trim = async () => {

                setTrimmedUrl(undefined);
                setLoading(true);
                try {
                    await extractor.trim(file,
                        startSecs,
                        durationSecs,
                        (file) => {
                            objectUrl = URL.createObjectURL(file);
                            setTrimmedUrl(objectUrl);
                        },
                        (msg => {
                            console.log(msg);
                            if (!cancelled) {
                                setError(msg ?? "Failed to trim video");
                            }
                        })
                    );

                    if (cancelled) return;
                } catch (err: any) {
                    if (!cancelled) {
                        setError(err?.message ?? "Failed to trim video");
                    }
                } finally {
                    if (!cancelled) {
                        setLoading(false);
                    }
                }
            };

            trim();

            return () => {
                cancelled = true;
                // Stop playback if the modal closes mid‑play

                // Revoke the object URL to free memory
                if (objectUrl) {
                    URL.revokeObjectURL(objectUrl);
                }

                // Clean up FFmpeg FS files (safe even if they don't exist)
                (async () => {
                    try {
                        /*await readerRef.current?.terminate();*/
                    } catch {
                        // ignore — FS may not exist yet
                    }
                })();
            };
        }
    }, [video, startSecs, durationSecs])

    return (
        <div className="clip-preview-container">
            {aspectRatio && startSecs !== null &&
                <VideoPreview videoUrl={trimmedUrl} aspectRatio={aspectRatio} />
            }
        </div>
    );
};
